import { render, staticRenderFns } from "./LineChartHistoryModal.vue?vue&type=template&id=2ca72b54&scoped=true&"
import script from "./LineChartHistoryModal.vue?vue&type=script&lang=js&"
export * from "./LineChartHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./LineChartHistoryModal.vue?vue&type=style&index=0&id=2ca72b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca72b54",
  null
  
)

export default component.exports